import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { ApiVersionBanner } from './components/layout/ApiVersionBanner';
import './styles/globals.css';

const root = createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ApiVersionBanner />
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
